import { render, staticRenderFns } from "./MarketStatistics.vue?vue&type=template&id=0d30a734&scoped=true&"
import script from "./MarketStatistics.vue?vue&type=script&lang=js&"
export * from "./MarketStatistics.vue?vue&type=script&lang=js&"
import style1 from "./MarketStatistics.vue?vue&type=style&index=1&id=0d30a734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d30a734",
  null
  
)

export default component.exports